import { render, staticRenderFns } from "./ThisHeader.vue?vue&type=template&id=628aa934&"
import script from "./ThisHeader.vue?vue&type=script&lang=js&"
export * from "./ThisHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports